var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "auto",
      background: "0 0",
      display: "block"
    },
    width: 200,
    height: 200,
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#6994b7",
    strokeWidth: 14.4,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;55.1413599195142 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.046s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 39.891,
    stroke: "#eee",
    strokeWidth: 7.2,
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;55.1413599195142 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.046s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 32.771,
    stroke: "#000",
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;45.299378454348094 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.046s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 47.171,
    stroke: "#000",
    fill: "none",
    strokeDasharray: "0 300"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dasharray",
    values: "15 300;66.03388996804073 300;15 300",
    keyTimes: "0;0.5;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "linear",
    keySplines: "0 0.4 0.6 1;0.4 0 1 0.6",
    begin: "-0.046s"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6994b7",
    stroke: "#000",
    d: "M97.2 50.1c0 6.1-1.2 12.2-3.5 17.9l-13.3-5.4c1.6-3.9 2.4-8.2 2.4-12.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M93.5 49.9c0 1.2 0 2.7-.1 3.9l-.4 3.6c-.4 2-2.3 3.3-4.1 2.8l-.2-.1c-1.8-.5-3.1-2.3-2.7-3.9l.4-3c.1-1 .1-2.3.1-3.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6994b7",
    stroke: "#000",
    d: "M85.4 62.7c-.2.7-.5 1.4-.8 2.1-.3.7-.6 1.4-.9 2-.6 1.1-2 1.4-3.2.8-1.1-.7-1.7-2-1.2-2.9.3-.6.5-1.2.8-1.8.2-.6.6-1.2.7-1.8m13.7 4.7c-.3.9-.7 1.7-1 2.6-.4.9-.7 1.7-1.1 2.5-.7 1.4-2.3 1.9-3.4 1.3-1.1-.7-1.5-2.2-.9-3.4.4-.8.7-1.5 1-2.3.3-.8.7-1.5.9-2.3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "360 50 50;0 50 50",
    keyTimes: "0;1",
    dur: "1s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keySplines: "0.5 0 0.5 1",
    begin: "-0.1s"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    stroke: "#000",
    d: "m86.9 35.3-6 2.4c-.4-1.2-1.1-2.4-1.7-3.5-.2-.5.3-1.1.9-1 2.2.6 4.7 1.2 6.8 2.1zm.2 0 6-2.4c-.6-1.7-1.5-3.3-2.3-4.9-.3-.7-1.2-.6-1.4.1-.6 2.5-1.2 4.9-2.3 7.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6994b7",
    stroke: "#000",
    d: "M82.8 50.1c0-3.4-.5-6.8-1.6-10-.2-.8-.4-1.5-.3-2.3.1-.8.4-1.6.7-2.4.7-1.5 1.9-3.1 3.7-4 1.8-.9 3.7-1.1 5.6-.3.9.4 1.7 1 2.4 1.8s1.3 1.7 1.7 2.8c1.5 4.6 2.2 9.5 2.3 14.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M86.3 50.2v-.9l-.1-.9-.1-1.9c0-.9.2-1.7.7-2.3.5-.7 1.3-1.2 2.3-1.4h.3c.9-.2 1.9 0 2.6.6.7.5 1.3 1.4 1.4 2.4l.2 2.2.1 1.1v1.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f92",
    d: "M93.2 34.6c.1.4-.3.8-.9 1-.6.2-1.2.1-1.4-.2-.1-.3.3-.8.9-1 .6-.2 1.2-.1 1.4.2zm-11.3 4.1c.1.3.7.3 1.3.1.6-.2 1-.6.9-.9-.1-.3-.7-.3-1.3-.1-.6.2-1 .6-.9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5 36.8c.1.3-.2.7-.6.8-.5.2-.9 0-1.1-.3-.1-.3.2-.7.6-.8.5-.2 1-.1 1.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M85.9 38.9c.2.6.8.9 1.4.7.6-.2.9-.9.6-2.1.3 1.2 1 1.7 1.6 1.5.6-.2.9-.8.8-1.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6994b7",
    stroke: "#000",
    d: "m86.8 42.3.4 2.2c.1.4.1.7.2 1.1l.1 1.1c.1 1.2-.9 2.3-2.2 2.3-1.3 0-2.5-.8-2.5-1.9l-.1-1c0-.3-.1-.6-.2-1l-.3-1.9m14-2.9.5 2.7c.1.5.2.9.2 1.4l.1 1.4c.1 1.5-.9 2.8-2.2 2.9-1.3 0-2.5-1.1-2.6-2.4l-.1-1.3c0-.4-.1-.8-.2-1.2l-.4-2.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1 34.1c.3.7 0 1.4-.7 1.6-.6.2-1.3-.1-1.6-.7-.2-.6 0-1.4.7-1.6.6-.3 1.3.1 1.6.7zm-5.6 2.2c.2.6-.1 1.2-.7 1.5-.6.2-1.3 0-1.5-.6-.3-.5.1-1.2.7-1.4.6-.3 1.3-.1 1.5.5z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6bd7a92a93ad1f142b3319b857218564.svg";
export { ForwardRef as ReactComponent };